export class CategoryStatistic {
    name: string;
    value: number;
    subCategories: CategoryStatistic[] = [];

    constructor(name: string, value: number) {
        this.name = name;
        this.value = value;
    }

    public get totalValue(): number {
        return this.value + this.subCategories.reduce((sum, current) => sum + current.totalValue, 0);
    }

    public addValue(value: number, subCats: CategoryStatistic[]): void {
        this.value += value;
        subCats.forEach(subCat => this.addSubCategory(subCat));
    }

    public addSubCategory(subCat: CategoryStatistic): void {
        const existingSubCat = this.subCategories.find(s => s.name === subCat.name);
        if (!existingSubCat) {
            this.subCategories.push(subCat);
            return;
        }
        existingSubCat.addValue(subCat.value, subCat.subCategories);
    }

    public changeByFactor(factor: number): void {
        this.value = this.value * factor;
        this.subCategories.forEach(s => s.changeByFactor(factor));
    }
}

export class SingleCategoryStatistic {
    name: string;
    value: number;
    subCategory: string;

    constructor(name: string, value: number, subCategory?: string) {
        this.name = name;
        this.value = value;
        this.subCategory = subCategory;
    }

    public toCategoryStatistic(): CategoryStatistic {
        if (this.subCategory) {
            const ret = new CategoryStatistic(this.name, 0);
            ret.addSubCategory(new CategoryStatistic(this.subCategory, this.value));
            return ret;
        }
        return new CategoryStatistic(this.name, this.value);
    }
}

export class CategoryStatistics {
    categories: CategoryStatistic[] = [];

    public get sum(): number {
        return this.categories.reduce((sum, current) => sum + current.totalValue, 0);
    }

    public add(cat: CategoryStatistic): void {
        const existingCat = this.categories.find(c => c.name === cat.name);
        if (!existingCat) {
            this.categories.push(cat);
            return;
        }
        existingCat.addValue(cat.value, cat.subCategories);
    }

    public addMany(cats: CategoryStatistic[]): void {
        cats.forEach(cat => this.add(cat));
    }

    public changeByFactor(factor: number): void {
        this.categories.forEach(c => c.changeByFactor(factor));
    }
}
